import { MANAGE_TABLE } from "app/ManageTables/types";
import { tableResponse, tableUpdate } from "helpers/reducers";
import { AnyAction } from "redux";
import { IGPTable } from "ui/Table/Table";
import {
    POS_PRODUCTS_FETCH_SUCCESS,
    POS_PRODUCTS_TABLE_UPDATE,
} from "../types";

function PosProductsTable(
    state: IGPTable = {
        id: "PosProductsTable",
        columns: [],
        availableColumns: [],
        elasticSearch: true,
        filterSettings: {
            open: false,
            total: 1,
        },
        filters: {
            active_filter: true,
        },
        filterData: [],
        search: "",
        sort: { name: "asc" },
        with: [],
    },
    action: AnyAction
) {
    switch (action.type) {
        case POS_PRODUCTS_FETCH_SUCCESS:
            if (action.response.config.params._table_id === state.id) {
                return tableResponse(state, action);
            }
            return state;
        case MANAGE_TABLE:
            if (action.data.id === state.id) {
                return {
                    ...state,
                    ...action.data,
                };
            }
            return state;
        case POS_PRODUCTS_TABLE_UPDATE:
            return tableUpdate(state, action);
        default:
            return state;
    }
}

export default PosProductsTable;
